import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext();

const API = axios.create({
  baseURL: '/api',
  withCredentials: true
});

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      const res = await API.get('/auth/me');
      setUser(res.data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  const login = async (email, password) => {
  const res = await API.post('/auth/login', { email, password });
  if (res.data.message === 'Login successful') {
    await checkAuth();
  }
  return res.data;
};

  const verify2FA = async (code) => {
  const res = await API.post('/auth/verify-2fa', { code });
  await checkAuth();
  return res.data;
};

  const logout = async () => {
    await API.post('/auth/logout');
    setUser(null);
  };

  const register = async (email, password) => {
    const res = await API.post('/auth/register', { email, password });
    return res.data;
  };

  const forgotPassword = async (email) => {
    const res = await API.post('/auth/forgot-password', { email });
    return res.data;
  };

  const resetPassword = async (token, password) => {
    const res = await API.post('/auth/reset-password', { token, password });
    return res.data;
  };

  return (
    <AuthContext.Provider value={{
      user, loading,
      login, verify2FA, logout,
      register, forgotPassword, resetPassword,
      checkAuth
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
export default AuthContext;